import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Col className="position-absolute top-25 start-50 translate-middle-x mt-4">
        <h1 className="fw-semibold text-secondary">{t("welcome.message")} </h1>
      </Col>
    </div>
  );
};

export default HomePage;
